import { toast } from 'sonner'

/** Copy a public share URL to the clipboard with standard toast feedback. */
export async function copyPublicUrl(url: string): Promise<boolean> {
  const value = url.trim()
  if (!value) {
    toast.error('No public link available yet.')
    return false
  }
  try {
    await navigator.clipboard.writeText(value)
    toast.success('Link copied')
    return true
  } catch {
    toast.error('Could not copy link')
    return false
  }
}
